import isURL from "validator/lib/isURL";
import { AbacusService } from "#gen/abacus/v2/abacus_pb.js";
import { ReportsService } from "#gen/abacus/v2/reports_pb.js";
import { AuditService } from "#gen/audit/v1/audit_pb.js";
import { BillingService } from "#gen/billing/v1/service_pb.js";
import { BrandsService } from "#gen/brands/v1/service_pb.js";
import { BundleService } from "#gen/bundles/v1/service_pb.js";
import { CodeService } from "#gen/codes/v3/codes_pb.js";
import { ComplianceService } from "#gen/compliance/v1/compliance_pb.js";
import { ConversionsDevelopersService } from "#gen/conversions_developers/v1/service_pb.js";
import { EntrypointService } from "#gen/entrypoints/v1/entrypoints_pb.js";
import { EventService } from "#gen/events/v1/service_pb.js";
import { FolderService } from "#gen/folder/v1/folders_pb.js";
import { FormsService } from "#gen/forms/v1/forms_pb.js";
import { PollService } from "#gen/forms/v1/poll_pb.js";
import { IdentitiesService } from "#gen/identities/v1/identities_pb.js";
import { IntegrationsService } from "#gen/integrations/v1/service_pb.js";
import { LegalService } from "#gen/legal/v1/legal_pb.js";
import { LinksService } from "#gen/links/v1/links_pb.js";
import { NotificationTemplateService } from "#gen/notification_templates/v1/notification_templates_pb.js";
import { NotificationService } from "#gen/notifications/v2/notifications_pb.js";
import { OnboardingService } from "#gen/onboarding/v1/onboarding_pb.js";
import { ComponentRegistryService } from "#gen/pages/v2/component_pb.js";
import { PageService } from "#gen/pages/v2/page_pb.js";
import { PixelTrackerService } from "#gen/pixel_tracker/v1/pixel_tracker_pb.js";
import { ProductService } from "#gen/products/v1/service_pb.js";
import { SearchService } from "#gen/search/v2/search_pb.js";
import { ShortUrlsService } from "#gen/shorturls/v1/shorturls_pb.js";
import { StaticAssetsService } from "#gen/staticassets/v1/static_assets_pb.js";
import { StatusService } from "#gen/status/v1/status_pb.js";
import { TagService } from "#gen/tag/v1/tag_pb.js";
import { WebhooksService } from "#gen/webhooks/v1/service_pb.js";
import {
	PUBLIC_ABACUS_URL,
	PUBLIC_AUDIT_URL,
	PUBLIC_BILLING_URL,
	PUBLIC_BRAND_URL,
	PUBLIC_BUNDLES_URL,
	PUBLIC_CLUSTER_ABACUS_URL,
	PUBLIC_CLUSTER_AUDIT_URL,
	PUBLIC_CLUSTER_BILLING_URL,
	PUBLIC_CLUSTER_BRAND_URL,
	PUBLIC_CLUSTER_BUNDLES_URL,
	PUBLIC_CLUSTER_CODES_URL,
	PUBLIC_CLUSTER_COMPLIANCE_URL,
	PUBLIC_CLUSTER_CONVERSIONS_DEVELOPERS_URL,
	PUBLIC_CLUSTER_EVENTS_URL,
	PUBLIC_CLUSTER_FOLDERS_URL,
	PUBLIC_CLUSTER_FORMS_URL,
	PUBLIC_CLUSTER_INTEGRATIONS_URL,
	PUBLIC_CLUSTER_LEGAL_URL,
	PUBLIC_CLUSTER_LINKS_URL,
	PUBLIC_CLUSTER_LLM_URL,
	PUBLIC_CLUSTER_NOTIFICATIONS_URL,
	PUBLIC_CLUSTER_NOTIFICATION_TEMPLATE_URL,
	PUBLIC_CLUSTER_ONBOARDING_URL,
	PUBLIC_CLUSTER_PAGES_URL,
	PUBLIC_CLUSTER_PIXEL_TRACKER_URL,
	PUBLIC_CLUSTER_POLLS_URL,
	PUBLIC_CLUSTER_POSIEDON_URL,
	PUBLIC_CLUSTER_PRODUCT_URL,
	PUBLIC_CLUSTER_REGISTRY_URL,
	PUBLIC_CLUSTER_SEARCH_URL,
	PUBLIC_CLUSTER_SHORT_URLS_URL,
	PUBLIC_CLUSTER_STATIC_ASSET_URL,
	PUBLIC_CLUSTER_STATUS_URL,
	PUBLIC_CLUSTER_TAG_URL,
	PUBLIC_CLUSTER_WEBHOOKS_URL,
	PUBLIC_CODES_URL,
	PUBLIC_COMPLIANCE_URL,
	PUBLIC_CONVERSIONS_DEVELOPERS_URL,
	PUBLIC_EVENTS_URL,
	PUBLIC_F1_APP_URL,
	PUBLIC_FOLDERS_URL,
	PUBLIC_FORMS_URL,
	PUBLIC_HOSTNAME,
	PUBLIC_INTEGRATIONS_URL,
	PUBLIC_LEGAL_URL,
	PUBLIC_LINKS_URL,
	PUBLIC_LLM_URL,
	PUBLIC_NOTIFICATIONS_URL,
	PUBLIC_NOTIFICATION_TEMPLATE_URL,
	PUBLIC_ONBOARDING_URL,
	PUBLIC_PAGES_URL,
	PUBLIC_PIXEL_TRACKER_URL,
	PUBLIC_POLLS_URL,
	PUBLIC_POSIEDON_URL,
	PUBLIC_PRODUCT_URL,
	PUBLIC_REGISTRY_URL,
	PUBLIC_SCANABILITY_URL,
	PUBLIC_SEARCH_URL,
	PUBLIC_SHORT_URLS_URL,
	PUBLIC_STATIC_ASSET_URL,
	PUBLIC_STATUS_URL,
	PUBLIC_TAG_URL,
	PUBLIC_WEBHOOKS_URL,
} from "$app/env/public";

export const PUBLIC_URLS = {
	hostname: PUBLIC_HOSTNAME,
	audit: PUBLIC_AUDIT_URL,
	codes: PUBLIC_CODES_URL,
	pixels: PUBLIC_PIXEL_TRACKER_URL,
	shortUrls: PUBLIC_SHORT_URLS_URL,
	bundles: PUBLIC_BUNDLES_URL,
	pages: PUBLIC_PAGES_URL,
	forms: PUBLIC_FORMS_URL,
	componentRegistry: PUBLIC_REGISTRY_URL,
	staticAssets: PUBLIC_STATIC_ASSET_URL,
	brands: PUBLIC_BRAND_URL,
	tags: PUBLIC_TAG_URL,
	folders: PUBLIC_FOLDERS_URL,
	posiedon: PUBLIC_POSIEDON_URL,
	products: PUBLIC_PRODUCT_URL,
	search: PUBLIC_SEARCH_URL,
	links: PUBLIC_LINKS_URL,
	status: PUBLIC_STATUS_URL,
	webhooks: PUBLIC_WEBHOOKS_URL,
	notificationTemplates: PUBLIC_NOTIFICATION_TEMPLATE_URL,
	notifications: PUBLIC_NOTIFICATIONS_URL,
	integrations: PUBLIC_INTEGRATIONS_URL,
	abacus: PUBLIC_ABACUS_URL,
	llm: PUBLIC_LLM_URL,
	f1App: PUBLIC_F1_APP_URL,
	billing: PUBLIC_BILLING_URL,
	conversionsDevelopers: PUBLIC_CONVERSIONS_DEVELOPERS_URL,
	scanability: PUBLIC_SCANABILITY_URL,
	legal: PUBLIC_LEGAL_URL,
	onboarding: PUBLIC_ONBOARDING_URL,
	events: PUBLIC_EVENTS_URL,
	compliance: PUBLIC_COMPLIANCE_URL,
	polls: PUBLIC_POLLS_URL,
};

const CLUSTER_URLS = {
	[AbacusService.typeName]: PUBLIC_CLUSTER_ABACUS_URL ?? PUBLIC_ABACUS_URL,
	[ReportsService.typeName]: PUBLIC_CLUSTER_ABACUS_URL ?? PUBLIC_ABACUS_URL,
	[AuditService.typeName]: PUBLIC_CLUSTER_AUDIT_URL ?? PUBLIC_AUDIT_URL,
	[CodeService.typeName]: PUBLIC_CLUSTER_CODES_URL ?? PUBLIC_CODES_URL,
	[ShortUrlsService.typeName]: PUBLIC_CLUSTER_SHORT_URLS_URL ?? PUBLIC_SHORT_URLS_URL,
	[BundleService.typeName]: PUBLIC_CLUSTER_BUNDLES_URL ?? PUBLIC_BUNDLES_URL,
	[PageService.typeName]: PUBLIC_CLUSTER_PAGES_URL ?? PUBLIC_PAGES_URL,
	[FormsService.typeName]: PUBLIC_CLUSTER_FORMS_URL ?? PUBLIC_FORMS_URL,
	[ComponentRegistryService.typeName]: PUBLIC_CLUSTER_REGISTRY_URL ?? PUBLIC_REGISTRY_URL,
	[StaticAssetsService.typeName]: PUBLIC_CLUSTER_STATIC_ASSET_URL ?? PUBLIC_STATIC_ASSET_URL,
	[BrandsService.typeName]: PUBLIC_CLUSTER_BRAND_URL ?? PUBLIC_BRAND_URL,
	[StatusService.typeName]: PUBLIC_CLUSTER_STATUS_URL ?? PUBLIC_STATUS_URL,
	[TagService.typeName]: PUBLIC_CLUSTER_TAG_URL ?? PUBLIC_TAG_URL,
	[IdentitiesService.typeName]: PUBLIC_CLUSTER_POSIEDON_URL ?? PUBLIC_POSIEDON_URL,
	[IntegrationsService.typeName]: PUBLIC_CLUSTER_INTEGRATIONS_URL ?? PUBLIC_INTEGRATIONS_URL,
	[ProductService.typeName]: PUBLIC_CLUSTER_PRODUCT_URL ?? PUBLIC_PRODUCT_URL,
	[SearchService.typeName]: PUBLIC_CLUSTER_SEARCH_URL ?? PUBLIC_SEARCH_URL,
	[LinksService.typeName]: PUBLIC_CLUSTER_LINKS_URL ?? PUBLIC_LINKS_URL,
	[FolderService.typeName]: PUBLIC_CLUSTER_FOLDERS_URL ?? PUBLIC_FOLDERS_URL,
	[WebhooksService.typeName]: PUBLIC_CLUSTER_WEBHOOKS_URL ?? PUBLIC_WEBHOOKS_URL,
	[NotificationTemplateService.typeName]: PUBLIC_CLUSTER_NOTIFICATION_TEMPLATE_URL ?? PUBLIC_NOTIFICATION_TEMPLATE_URL,
	[NotificationService.typeName]: PUBLIC_CLUSTER_NOTIFICATIONS_URL ?? PUBLIC_NOTIFICATIONS_URL,
	[BillingService.typeName]: PUBLIC_CLUSTER_BILLING_URL ?? PUBLIC_BILLING_URL,
	[ConversionsDevelopersService.typeName]: PUBLIC_CLUSTER_CONVERSIONS_DEVELOPERS_URL ?? PUBLIC_CONVERSIONS_DEVELOPERS_URL,
	[PixelTrackerService.typeName]: PUBLIC_CLUSTER_PIXEL_TRACKER_URL ?? PUBLIC_PIXEL_TRACKER_URL,
	[EntrypointService.typeName]: PUBLIC_CLUSTER_CODES_URL ?? PUBLIC_CODES_URL,
	[LegalService.typeName]: PUBLIC_CLUSTER_LEGAL_URL ?? PUBLIC_LEGAL_URL,
	[OnboardingService.typeName]: PUBLIC_CLUSTER_ONBOARDING_URL ?? PUBLIC_ONBOARDING_URL,
	[EventService.typeName]: PUBLIC_CLUSTER_EVENTS_URL ?? PUBLIC_EVENTS_URL,
	[ComplianceService.typeName]: PUBLIC_CLUSTER_COMPLIANCE_URL ?? PUBLIC_COMPLIANCE_URL,
	[PollService.typeName]: PUBLIC_CLUSTER_POLLS_URL ?? PUBLIC_POLLS_URL,
	llm: PUBLIC_CLUSTER_LLM_URL ?? PUBLIC_LLM_URL,
} as Record<string, string>;

export const secureProtocol = "https://";
export const insecureProtocol = "http://";
export const smsProtocol = "sms:";
export const telProtocol = "tel:";
export const mailtoProtocol = "mailto:";

function maybeProtocol(input: string, protocol: string): boolean {
	return input.length >= secureProtocol.length && input.startsWith(protocol);
}

function maybeSmsProtocol(input: string): boolean {
	return input.length <= smsProtocol.length && smsProtocol.startsWith(input);
}

function maybeTelProtocol(input: string): boolean {
	return input.length <= telProtocol.length && telProtocol.startsWith(input);
}

function maybeMailtoProtocol(input: string): boolean {
	return input.length <= mailtoProtocol.length && mailtoProtocol.startsWith(input);
}

function maybeDeepLink(input: string): boolean {
	return Boolean(input.match(/\b(?!https?:\/\/)([a-zA-Z][a-zA-Z0-9+.-]*:[^\s]+)/));
}

export function validateUrl(url: string): boolean {
	const trimmed = url.trim();
	return trimmed !== "" && isURL(trimmed);
}

export function normalizeUrl(input: string, options?: { hasSubstitutionToken: boolean }): string {
	const trimmedInput = input.trim();
	if (!trimmedInput?.length) return trimmedInput;
	if (options?.hasSubstitutionToken || maybeDeepLink(trimmedInput) || maybeProtocol(trimmedInput, insecureProtocol) || maybeProtocol(trimmedInput, secureProtocol) || maybeSmsProtocol(trimmedInput) || maybeTelProtocol(trimmedInput) || maybeMailtoProtocol(trimmedInput)) {
		return trimmedInput;
	} else if (secureProtocol.startsWith(trimmedInput) || insecureProtocol.startsWith(trimmedInput) || trimmedInput.startsWith(smsProtocol) || trimmedInput.startsWith(telProtocol) || trimmedInput.startsWith(mailtoProtocol)) {
		return trimmedInput;
	}
	return `${secureProtocol}${trimmedInput}`;
}

export function getClusterURL(url: URL): string | undefined {
	for (const key in CLUSTER_URLS) {
		if (url.pathname.startsWith("/" + key)) {
			return CLUSTER_URLS[key];
		}
	}
	return undefined;
}

export function stripSearchParams(str: string): string {
	if (!str) {
		return "";
	}
	try {
		const url = new URL(str);
		url.search = "";
		return url.toString().replace(/\/$/, "");
	} catch {
		return str;
	}
}

export function extractDomain(url: URL): string {
	const hostname = url.hostname;
	if (hostname === "localhost") {
		return hostname;
	}
	const segments = hostname.split(".");
	segments.splice(0, segments.length - 2);
	return segments.join(".");
}

/**
 * Normalizes a hostname for exact comparison: trims, lowercases (DNS is case-insensitive),
 * strips a port and a trailing FQDN dot. Does NOT strip `www` — subdomains are significant
 * (e.g. `go.flws.it` !== `flws.it`).
 */
export function normalizeHost(host?: string): string {
	if (!host) return "";
	return host.trim().toLowerCase().replace(/\.$/, "").replace(/:\d+$/, "");
}

const shortNames: Record<string, string> = {
	[telProtocol]: "Call me",
	[smsProtocol]: "Send me a text",
	[mailtoProtocol]: "Send me an email",
	[secureProtocol]: "Visit my website",
};

export function getShortNameFromUrl(url: string): string {
	if (url.startsWith(telProtocol)) return shortNames[telProtocol];
	if (url.startsWith(smsProtocol)) return shortNames[smsProtocol];
	if (url.startsWith(mailtoProtocol)) return shortNames[mailtoProtocol];
	if (url.startsWith(secureProtocol) || url.startsWith(insecureProtocol)) return shortNames[secureProtocol];
	return "Download my app";
}
